<template>
    <div class="componentTextPersona">
        <i class="fa-solid fa-user-tie-hair"></i>
        <p class="title-text-persona">Profil type</p>


        <div class="genre">
            <h3>Femme</h3>
            <i class="fa-solid fa-venus"></i>
        </div>

        <div class="age">
            <p>âgée de</p>
            <h3>45-54 ans</h3>
        </div>
        <div class="country">
            <p>de</p>
            <h3>France</h3>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
        },
    }
</script>
